<template>
	<div class="title_wrap">
		<transition name="slide-fade">
			<div>
				<div class="title_area d_flex justify_between align_items_center">
					<h2 v-if="!isMenuOpen">
						{{ this.titleName }}
					</h2>
					<h2 v-else>{{ $t('merchant_management.menu') }}</h2>
					<div class="d_flex align_items_center">
						<div v-if="isMenuOpen" class="d_flex justify_end">
							<div class="d_flex align_items_center">
								<span class="icon_language"></span>
							</div>
							<div class="d_flex align_items_center">
								<select v-model="s_locale_code" id="select_language">
									<option
										v-for="item in locales"
										:value="item.code"
										:key="item.code"
									>
										{{ item.name }}
									</option>
								</select>
							</div>
						</div>
						<a class="mobile_menu_icon" @click="menuOpen"
							><img
								v-if="isMenuOpen === false"
								:src="this.menuIcon.open"
								alt=""
							/>
							<img v-else :src="this.menuIcon.close" alt="" />
						</a>
					</div>
				</div>
			</div>
		</transition>
		<div v-if="isMenuOpen">
			<div class="menuOn">
				<ul>
					<li class="list_item" @click="toRoute({ name: 'qr-payment' })">
						<a class="title_m">{{
							$t('merchant_management.title.qr_payment')
						}}</a>
						<span class="right_arrow icon"></span>
					</li>
					<li class="list_item" @click="toRoute({ name: 'payment-list' })">
						<a class="title_m">{{
							$t('merchant_management.title.payment_list')
						}}</a>
						<span class="right_arrow icon"></span>
					</li>
					<li
						class="list_item"
						@click="toRoute({ name: 'merchant-management' })"
					>
						<a class="title_m">{{
							$t('merchant_management.title.merchant_management')
						}}</a>
						<span class="right_arrow icon"></span>
					</li>

					<li class="list_item" @click="toRoute({ name: 'mypage-account' })">
						<a class="title_m">{{ $t('merchant_management.title.account') }}</a>
						<span class="right_arrow icon"></span>
					</li>
					<li class="list_item" @click="toRoute({ name: 'setup' })">
						<a class="title_m">{{ $t('merchant_management.title.setup') }}</a>
						<span class="right_arrow icon"></span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store/store';

export default {
	name: 'TitleComponent',
	// props: {
	// 	isScroll: {
	// 		type: Boolean,
	// 		default: false,
	// 	},
	// },
	data() {
		return {
			isMenuOpen: false,
			menuIcon: {
				open: require('@/assets/images/icon/mobile_menu.png'),
				close: require('@/assets/images/icon/mobile_menu_close.png'),
			},
			title: '',
		};
	},
	computed: {
		...mapState('common', ['locales']),
		s_locale_code: {
			get() {
				return this.$store.state.common.locale;
			},
			set(value) {
				this.$store.dispatch('common/setLocale', value);
			},
		},
		is_logged_in() {
			return store.getters.is_logged_in;
		},
		currentRoute() {
			return this.$route.name;
		},
		titleName() {
			if (this.currentRoute === 'qr-payment') {
				return this.$t('merchant_management.title.qr_payment');
			} else if (this.currentRoute === 'payment-list') {
				return this.$t('merchant_management.title.payment_list');
			} else if (this.currentRoute === 'merchant-management') {
				return this.$t('merchant_management.title.merchant_management');
			} else if (this.currentRoute === 'setup') {
				return this.$t('merchant_management.title.setup');
			} else if (this.currentRoute === 'setup-notice') {
				return '';
			} else if (this.currentRoute === 'setup-faq') {
				return '';
			} else if (this.currentRoute === 'setup-cs') {
				return '';
			} else {
				return false;
			}
		},
	},
	methods: {
		menuOpen() {
			this.isMenuOpen = !this.isMenuOpen;
		},
		toRoute(obj) {
			this.isMenuOpen = false;
			this.$router.push(obj);
		},
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
.slide-fade-enter-active {
	transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
	transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
	transform: translateX(20px);
	opacity: 0;
}
</style>
